module.exports = __webpack_public_path__ + "static/media/levain_bg_img_1.6606bbad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slider/levain_bg_img_1.jpg
// module id = 1056
// module chunks = 0